import facebookIcon from '../../../assets/icons/facebook.svg';
import instagramIcon from '../../../assets/icons/instagram.svg';
import twitterIcon from '../../../assets/icons/twitter.svg';
import linkedinIcon from '../../../assets/icons/linkedin.svg';
import telegramIcon from '../../../assets/icons/telegram.svg';

const socialLinks = [
  {
    icon: facebookIcon,
    alt: 'facebook logo',
    link: 'https://www.facebook.com/TAPSI.ir',
  },
  {
    icon: instagramIcon,
    alt: 'instagram logo',
    link: 'https://www.instagram.com/tapsi_ir/',
  },
  {
    icon: twitterIcon,
    alt: 'twitter logo',
    link: 'https://twitter.com/TAPSI_ir',
  },
  {
    icon: linkedinIcon,
    alt: 'linkedin logo',
    link: 'https://www.linkedin.com/company/tap30',
  },
  {
    icon: telegramIcon,
    alt: 'telegram logo',
    link: 'https://t.me/tapsi_cab',
  },
];

export default socialLinks;
